// Shared vocabulary for the case workspace. Kept in one file so the status
// pills, priority colours, dropdowns and deal-stage rule can never disagree.

export const CASE_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'open', label: 'Open' },
  { value: 'waiting_customer', label: 'Waiting on Customer' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'pending_internal', label: 'Pending Internal' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const CASE_STATUS_LABELS = Object.fromEntries(
  CASE_STATUSES.map((s) => [s.value, s.label])
);

export const CASE_STATUS_STYLES = {
  new: 'border-primary/40 text-primary bg-primary/10',
  open: 'border-blue-400/40 text-blue-300 bg-blue-400/10',
  waiting_customer: 'border-amber-400/40 text-amber-300 bg-amber-400/10',
  in_progress: 'border-violet-400/40 text-violet-300 bg-violet-400/10',
  pending_internal: 'border-white/20 text-white/60 bg-white/5',
  resolved: 'border-green-400/40 text-green-300 bg-green-400/10',
  closed: 'border-white/10 text-white/40 bg-white/5',
};

export const CASE_PRIORITIES = [
  { value: 'low', label: 'Low', dot: 'bg-white/30', text: 'text-white/50', ring: 'border-white/15' },
  { value: 'medium', label: 'Medium', dot: 'bg-blue-400', text: 'text-blue-300', ring: 'border-blue-400/40' },
  { value: 'high', label: 'High', dot: 'bg-amber-400', text: 'text-amber-300', ring: 'border-amber-400/40' },
  { value: 'urgent', label: 'Urgent', dot: 'bg-red-500', text: 'text-red-400', ring: 'border-red-500/50' },
];

export function priorityMeta(value) {
  return CASE_PRIORITIES.find((p) => p.value === value) || CASE_PRIORITIES[1];
}

export const CASE_CATEGORIES = [
  { value: 'general_support', label: 'General Support' },
  { value: 'booking', label: 'Booking' },
  { value: 'order', label: 'Order' },
  { value: 'hardware', label: 'Hardware' },
  { value: 'b2b_corporate', label: 'B2B / Corporate Event' },
];

export const DEAL_STAGES = [
  { value: 'enquiry', label: 'Enquiry' },
  { value: 'quoting', label: 'Quoting' },
  { value: 'provisional', label: 'Provisional' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'invoiced', label: 'Invoiced' },
  { value: 'completed', label: 'Completed' },
  { value: 'lost', label: 'Lost' },
];

// The Deal Stage control only applies to a corporate event case.
export const B2B_CATEGORY = 'b2b_corporate';

export const DRIVER_TIERS = ['Novice', 'Casual', 'Sim Racer', 'Pro'];

export const TIME_SLOTS = [
  '09:00', '10:00', '11:00', '12:00', '13:00', '14:00',
  '15:00', '16:00', '17:00', '18:00', '19:00', '20:00',
];

export const inputClass =
  'w-full bg-[#111115] border border-white/10 text-white text-sm px-3 py-2 outline-none focus:border-primary/60 transition-colors placeholder:text-white/20';